import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconListSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconListSparkle"><Path d="M3.5 18.5H7.5M3.5 12H9.5M3.5 5.5H20.5M17 10.5L18.5 13.5L21.5 15L18.5 16.5L17 19.5L15.5 16.5L12.5 15L15.5 13.5L17 10.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconListSparkle;
